import { Popover } from "@msuite/ui/popover";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { UserPopover } from "@/components/popovers/user-popover";
import { client } from "@/hono";

/** Props Interface */
interface UserCardMentionInlineProps {
	userId: string;
}

export function UserCardMentionInline({ userId }: UserCardMentionInlineProps) {
	/** Hooks */
	const { data: user } = useQuery({
		queryKey: ["user", userId],
		queryFn: async () => {
			if (!userId) return null;
			const response = await client.users[":userId"].$get({
				param: {
					userId,
				},
			});
			const data = await responseHandler(response);
			return data.user;
		},
		enabled: !!userId,
	});

	return (
		<Popover
			trigger="hover"
			render={() => <UserPopover userId={userId} />}
		>
			<p className="text-accent-500!">
				@{" "}
				<span className="underline underline-offset-3">
					{user?.firstName} {user?.lastName}
				</span>
			</p>
		</Popover>
	);
}
